import OriginalInputNumber from './InputNumber.svelte';
import Label from './Label.svelte';
import Icon from '../icon/Icon.svelte';
const InputNumber = OriginalInputNumber;
InputNumber.Label = Label;
InputNumber.Leading = Icon;
InputNumber.Trailing = Icon;
export default InputNumber;
